import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import EmptyCheckbox from '../../../../assets/lernsets/icons/checkbox.svg';
import SelectedCheckbox from '../../../../assets/lernsets/icons/selectedCheckbox.svg';
import { palette, spaces } from '../../../../assets/styles/themes/tokens';

interface CollectionVisibilityProps {
	registration: UseFormRegisterReturn;
	initialValue?: boolean;
}

const CollectionVisibility = ({
	registration,
	initialValue = false,
}: CollectionVisibilityProps) => {
	const { t } = useTranslation();
	const { ref, ...field } = registration;

	return (
		<Box data-testid="collection-visibility-container">
			<FormControlLabel
				sx={{
					margin: 0,
					'& .MuiFormControlLabel-label': {
						color: palette.text.primary,
					},
				}}
				control={
					<Checkbox
						name={field.name}
						onChange={field.onChange}
						onBlur={field.onBlur}
						color="primary"
						size="small"
						data-testid="collection-visibility-input"
						icon={<EmptyCheckbox />}
						checkedIcon={<SelectedCheckbox />}
						defaultChecked={initialValue}
						inputRef={ref}
						sx={{
							p: 0,
							mr: spaces.xs,
						}}
					/>
				}
				labelPlacement="end"
				label={
					<Typography variant="body1" color={palette.text.primary}>
						{t('Public')}
					</Typography>
				}
			/>
		</Box>
	);
};

export default CollectionVisibility;
